import { render, staticRenderFns } from "./LeagueOverview.vue?vue&type=template&id=57a930a5&"
import script from "./LeagueOverview.vue?vue&type=script&lang=js&"
export * from "./LeagueOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/workspace/Draft App Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout,VList,VListTile,VListTileContent})
